type Props = {
  LanguageState: string;
  seMaintenanceTitle: string;
  seMaintenanceBody: string;
  enMaintenanceTitle: string;
  enMaintenanceBody: string;
};

export default function MaintenancePage({
  LanguageState,
  seMaintenanceTitle,
  seMaintenanceBody,
  enMaintenanceTitle,
  enMaintenanceBody,
}: Props) {
  return (
    <div className="flex flex-col w-full max-w-7xl pt-safe-offset-12 overflow-auto scrollbar-hide">
      <div className="hero">
        <div className="px-safe-offset-8 py-24 md:py-36 lg:py-56 flex flex-col space-y-4 mx-auto h-full justify-center items-center text-white text-2xl text-center">
          {LanguageState === "swedish" ? (
            <h1
              className="text-4xl font-display font-medium tracking-wider"
              dangerouslySetInnerHTML={{ __html: seMaintenanceTitle }}
            />
          ) : (
            <h1
              className="text-4xl font-display font-medium tracking-wider"
              dangerouslySetInnerHTML={{ __html: enMaintenanceTitle }}
            />
          )}
        </div>
      </div>
      <div className="px-safe-offset-4 mb-safe-offset-4">
        <div className="bg-[#DBE3E7] dark:bg-zinc-800 p-4 sm:p-6 md:p-8 lg:p-10 max-w-3xl rounded-lg text-sm mx-auto -mt-10 md:-mt-20">
          <div className="flex flex-col space-y-4">
            {LanguageState === "swedish" ? (
              <p dangerouslySetInnerHTML={{ __html: seMaintenanceBody }} />
            ) : (
              <p dangerouslySetInnerHTML={{ __html: enMaintenanceBody }} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
